const toMinutes = time => {
  const [hour, minute] = time.split(':').map(Number);
  return hour * 60 + minute;
};

// 요일+시작시간+종료시간+강의실+강사가 모두 같은 행을 찾는다 (하나라도 다르면 유효한 별개 스케줄)
export const findDuplicateScheduleRowIndex = scheduleRows => {
  const seen = new Set();
  for (let i = 0; i < scheduleRows.length; i++) {
    const row = scheduleRows[i];
    const key = `${row.dayOfWeek}_${row.startTime}_${row.endTime}_${row.roomId}_${row.trainerId}`;
    if (seen.has(key)) {
      return i;
    }
    seen.add(key);
  }
  return -1;
};

// 같은 요일+같은 강사에서 시간이 겹치는 행 쌍을 찾는다. 한 강사가 동시에 두 수업을 할 수 없으므로
// 강의실은 무관하다 (강의실이 같아도 강사가 다르면 겹침이 아니다 — 같은 강의실에서 여러 그룹레슨 동시 운영 가능)
export const findOverlappingScheduleRowIndices = scheduleRows => {
  for (let i = 0; i < scheduleRows.length; i++) {
    const a = scheduleRows[i];
    const aStart = toMinutes(a.startTime);
    const aEnd = toMinutes(a.endTime);
    for (let j = i + 1; j < scheduleRows.length; j++) {
      const b = scheduleRows[j];
      if (a.dayOfWeek !== b.dayOfWeek || a.trainerId !== b.trainerId) continue;
      const bStart = toMinutes(b.startTime);
      const bEnd = toMinutes(b.endTime);
      if (aStart < bEnd && bStart < aEnd) {
        return [i, j];
      }
    }
  }
  return null;
};
